import React, { useState, useEffect } from 'react';
import Select from "react-select";
import BasicPagination from '../Pagination';
import CommanInput from '../Constent/CommanInput';
import CommanDropDown from '../Constent/CommanDropDown';
import { Button } from 'react-bootstrap';
import { Editor } from "react-draft-wysiwyg";
import { convertToRaw, EditorState, ContentState } from "draft-js";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { DELETS_WITH_TOKEN, GET_WITH_TOKEN, Post_WITH_TOKEN } from '../../Backend/Bakend';
import { showToast } from '../Constent/Toast';

const BookingCategories = () => {
  const [bookingData, setBookingData] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [image, setImage] = useState('');
  const [search, setSearch] = useState('');
  const [CurrentPage, setCurrentPage] = useState(1);
  const [IsEdit, setIsEdit] = useState(false);
  const [IsEditId, setIsEditId] = useState('');
  const [errors, setErrors] = useState({});
  const [bookingHeaderImagesArray, setBookingHeaderImagesArray] = useState([]);

  const [relatedPostList, setRelatedPostList] = useState([]);
  const [selectedPostIds, setSelectedPostIds] = useState([]);
  const [selectedPostNames, setSelectedPostNames] = useState([]);

  const [Data, setData] = useState({
    name: '',
    slug: '',
    status: 1,
    category_images: '',
    title_one: '',
    title_two: '',
    title_third: '',
    title_four: '',
    title_five: '',
    about_tour_title: '',
    about_tour: EditorState.createEmpty(),
    seo_content: EditorState.createEmpty(),
    images: []
  });

  useEffect(() => {
    getPostShow(1);
    GetCat();
    getAllPostsForDropdown();
  }, []);

  useEffect(() => {
    if (selectedPostIds.length > 0 && relatedPostList.length > 0) {
      const names = relatedPostList
        .filter(item => selectedPostIds.includes(item.value))
        .map(item => item.name);
      setSelectedPostNames(names);
    } else {
      setSelectedPostNames([]);
    }
  }, [selectedPostIds, relatedPostList]);

  const getAllPostsForDropdown = () => {
    GET_WITH_TOKEN(
      '/api/moreblogs',
      '',
      res => {
        if (res?.blogs && Array.isArray(res.blogs)) {
          const formatted = res.blogs.map(post => ({
            value: post.id,
            name: post.name
          }));
          setRelatedPostList(formatted);
        } else {
          setRelatedPostList([]); // safety
        }
      },
      err => console.log(err)
    );
  };


const handleRelatedPostChange = (selected) => {
  if (!selected || selected.length === 0) {
    setSelectedPostIds([]);
    setSelectedPostNames([]);
    return;
  }

  setSelectedPostIds(selected.map(item => item.value));
  setSelectedPostNames(selected.map(item => item.name));
};


const removeRelatedPost = (index) => {
  const names = [...selectedPostNames];
  names.splice(index, 1);
  setSelectedPostNames(names);

  const idsArray = [...selectedPostIds]; // now it's already an array
  idsArray.splice(index, 1);
  setSelectedPostIds(idsArray);
};


  const GetCat = () => {
    GET_WITH_TOKEN(
      '/api/base-categories',
      '',
      f => {
        // showToast(f.message || f.msg);
      },
      n => {
        showToast(n.message || n.msg || 'Something went wrong');
      }
    );
  };

  // Convert HTML content to EditorState for rich text fields
  const convertHtmlToEditorState = (htmlContent) => {
    if (!htmlContent || htmlContent === '') {
      return EditorState.createEmpty();
    }
    try {
      const contentBlock = htmlToDraft(htmlContent);
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      return EditorState.createWithContent(contentState);
    } catch (error) {
      console.error('Error converting HTML to EditorState:', error);
      return EditorState.createEmpty();
    }
  };

  const ShowById = id => {
    GET_WITH_TOKEN(
      `/api/booking-categories/${id}`,
      '',
      success => {
        if (success?.data) {
          setData({
            name: success.data.name || '',
            slug: success.data.slug || '',
            status: success.data.status === 1 ? 1 : 0,
            category_images: success.data.category_images || '',
            title_one: success.data.title_one || '',
            title_two: success.data.title_two || '',
            title_third: success.data.title_third || '',
            title_four: success.data.title_four || '',
            title_five: success.data.title_five || '',
            about_tour_title: success.data.about_tour_title || '',
            about_tour: convertHtmlToEditorState(success.data.about_tour),
            seo_content: convertHtmlToEditorState(success.data.seo_content)
          });
          setImage('');
          // Handle existing images array from API response
          // API returns images as array of objects with img_path property
          const existingImages = success.data.images?.map(img => ({
            img_path: img.img_path || img,
            img_txt: img.img_txt || '',
            isnew: false
          })) || [];

          setData(prevData => ({
            ...prevData,
            images: existingImages
          }));
          setBookingHeaderImagesArray([]); // Existing images from server, no file objects

          if (success.data.explore_blog) {
            const idsArray = success.data.explore_blog.split(',').map(id => Number(id)); // array of numbers
            setSelectedPostIds(idsArray);

            const names = relatedPostList
              .filter(item => idsArray.includes(item.value))
              .map(item => item.name);

            setSelectedPostNames(names);
          } else {
            setSelectedPostIds([]);
            setSelectedPostNames([]);
          }


          setIsEdit(true);
          setIsEditId(id);
        }
      },
      error => console.log(error),
      fail => console.log(fail)
    );
  };

  const getPostShow = page => {
    setBookingData([]);
    GET_WITH_TOKEN(
      `/api/booking-categories/all?page=${page}&search=${search}`,
      '',
      success => {
        if (success?.data?.data) {
          setBookingData(success.data.data);
          setTotalPage(success.data.last_page);
          setCurrentPage(success.data.current_page);
        }
      },
      error => console.log(error),
      fail => console.log(fail)
    );
  };

  const deletePost = id => {
    DELETS_WITH_TOKEN(
      `/api/booking-categories/${id}`,
      '',
      success => {
        showToast(success?.message || 'Booking category deleted');
        getPostShow(1);
      },
      error => console.log(error),
      fail => console.log(fail)
    );
  };

  const StatusData = [
    { id: 1, name: 'Active', value: 1 },
    { id: 0, name: 'Inactive', value: 0 }
  ];

  const onChange = (e, name) => {
    setData({ ...Data, [name]: e });
  };

  const resetForm = () => {
    setData({
      name: '',
      slug: '',
      status: 1,
      category_images: '',
      title_one: '',
      title_two: '',
      title_third: '',
      title_four: '',
      title_five: '',
      about_tour_title: '',
      about_tour: EditorState.createEmpty(),
      seo_content: EditorState.createEmpty(),
      images: []
    });
    setImage('');
    setBookingHeaderImagesArray([]);
    setSelectedPostNames([]);
    setSelectedPostIds([]);
    setIsEdit(false);
    setIsEditId('');
  };

  const AddBookingHeaderImages = (e) => {
    const fileList = e.target.files;
    const updatedImagesArray = [...bookingHeaderImagesArray];
    const newImages = [];

    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i];
      const newImage = URL.createObjectURL(file);
      
      // Prepare new image object
      newImages.push({
        img_path: newImage,
        img_txt: '',
        isnew: true
      });
      
      // Add file to array for submission
      updatedImagesArray.push(file);
    }

    // Update Data.images with all new images at once
    setData((prevData) => ({
      ...prevData,
      images: [
        ...(prevData.images || []),
        ...newImages
      ],
    }));

    setBookingHeaderImagesArray(updatedImagesArray);
  };

  const DeleteBookingHeaderImage = (index) => {
    const deletedImage = Data.images[index];
    if (!deletedImage) return;

    // Remove from Data.images
    setData((prevData) => ({
      ...prevData,
      images: prevData.images.filter((_, idx) => idx !== index),
    }));

    // Only remove from imageArray if it was a new upload
    if (deletedImage.isnew) {
      const newImages = Data.images.filter((img) => img.isnew);
      const deleteNewIndex = newImages.findIndex((im) => im.img_path === deletedImage.img_path);
      if (deleteNewIndex !== -1) {
        setBookingHeaderImagesArray((prevArray) => 
          prevArray.filter((_, idx) => idx !== deleteNewIndex)
        );
      }
    }
  };

  // Safely convert EditorState to HTML with error handling
  const convertEditorStateToHtml = (editorState) => {
    try {
      if (!editorState || typeof editorState.getCurrentContent !== 'function') {
        return '';
      }
      const contentState = editorState.getCurrentContent();
      const rawContentState = convertToRaw(contentState);
      return draftToHtml(rawContentState);
    } catch (error) {
      console.error('Error converting EditorState to HTML:', error);
      return '';
    }
  };

  const handleSubmit = () => {
    let tempErrors = {};

    // Required field validations
    if (!Data.name || Data.name.trim() === '') tempErrors.name = "Name is required";
    if (!Data.slug || Data.slug.trim() === '') tempErrors.slug = "Slug is required";
    
    // Validation for new fields
    if (!Data.title_one || Data.title_one.trim() === '') tempErrors.title_one = "Title One is required";
    if (!Data.title_two || Data.title_two.trim() === '') tempErrors.title_two = "Title Two is required";
    if (!Data.title_third || Data.title_third.trim() === '') tempErrors.title_third = "Title Third is required";
    if (!Data.title_four || Data.title_four.trim() === '') tempErrors.title_four = "Title Four is required";
    if (!Data.title_five || Data.title_five.trim() === '') tempErrors.title_five = "Title Five is required";
    if (!Data.about_tour_title || Data.about_tour_title.trim() === '') tempErrors.about_tour_title = "About Tour Title is required";
    
    // Check if rich text field has content
    const aboutTourContent = Data.about_tour?.getCurrentContent?.()?.getPlainText?.()?.trim();
    if (!aboutTourContent || aboutTourContent === '') tempErrors.about_tour = "About Tour is required";

    setErrors(tempErrors);

    // Stop submission if there are errors
    if (Object.keys(tempErrors).length > 0) return;

    // Convert EditorState to HTML for submission
    const aboutTourHtml = convertEditorStateToHtml(Data.about_tour);

    // FormData submission
    const formdata = new FormData();
    formdata.append('name', Data.name);
    formdata.append('slug', Data.slug);
    formdata.append('status', Data.status);
    if (image) formdata.append('category_images', image);
    
    // Add new text fields
    formdata.append('title_one', Data.title_one || '');
    formdata.append('title_two', Data.title_two || '');
    formdata.append('title_third', Data.title_third || '');
    formdata.append('title_four', Data.title_four || '');
    formdata.append('title_five', Data.title_five || '');
    formdata.append('about_tour_title', Data.about_tour_title || '');
    formdata.append('about_tour', aboutTourHtml);
    formdata.append('seo_content', convertEditorStateToHtml(Data.seo_content));
    
    // Add multiple booking_header_images
    // New images (files) - send as binary
    let newImageFileIndex = 0;
    Data.images.forEach((img) => {
      if (img.isnew) {
        const file = bookingHeaderImagesArray[newImageFileIndex];

        if (file) {
          formdata.append('booking_header_images[]', file);
          formdata.append('img_txt[]', img.img_txt || '');
          newImageFileIndex++;
        }
      }
    });
    
    // Existing images (URLs) - send as text with same field name
    if (IsEdit) {
      Data.images?.forEach((img) => {
        if (!img.isnew && img.img_path) {
          // Send existing images as URLs with same field name
          formdata.append('booking_header_images-exist[]', img.img_path);
          formdata.append('img_txt[]', img.img_txt || '');
        }
      });
    }

    formdata.append('explore_blog', selectedPostIds.join(','));
    
    if (IsEdit) formdata.append('_method', 'PUT');

    Post_WITH_TOKEN(
        IsEdit ? `/api/booking-categories/${IsEditId}` : '/api/booking-categories',
        formdata,
        success => {
            if (success?.errors) {
            // API returned validation errors
            setErrors(success.errors);
            // Optionally, show a toast for error
            showToast("Please fix the validation errors", "error"); // if your toast supports type
            return;
        }

        // Otherwise, submission succeeded
        showToast(IsEdit ? 'Booking category updated successfully' : 'Booking category added successfully');
        getPostShow(1);
        setErrors({});
        resetForm();

        // Close offcanvas like clicking the close button
        const closeBtn = document.querySelector('#offcanvasRight .btn-close');
        if (closeBtn) closeBtn.click();
    },
    error => console.log(error),
    fail => console.log(fail)
    );

  };


  return (
    <div>
      <div className="container mt-1">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <p style={{ fontSize: '25px' }}>Booking Categories</p>

                <div className="mb-3 mt-4 d-flex">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Name"
                    style={{ width: '20%' }}
                    onChange={e => setSearch(e.target.value)}
                  />

                  <button
                    onClick={() => getPostShow(CurrentPage)}
                    type="button"
                    className="ms-4"
                    style={{
                      backgroundColor: '#008c93',
                      color: '#fff',
                      border: 'none',
                      padding: '7px 15px',
                      borderRadius: '8px'
                    }}
                  >
                    Search
                  </button>

                  <button
                    type="button"
                    className="ms-2"
                    style={{
                      backgroundColor: 'transparent',
                      color: '#000',
                      padding: '7px 15px',
                      borderRadius: '8px',
                      border: '1px solid gray'
                    }}
                    onClick={() => {
                      setSearch('');
                      getPostShow(1);
                    }}
                  >
                    Reset
                  </button>

                  <button
                    type="button"
                    className="ms-2"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRight"
                    aria-controls="offcanvasRight"
                    style={{
                      backgroundColor: '#366fe9',
                      color: '#000',
                      padding: '7px 15px',
                      borderRadius: '8px',
                      border: '1px solid gray'
                    }}
                    onClick={() => {
                        resetForm();
                        setErrors({});
                    }}
                  >
                    Add New
                  </button>
                </div>
              </div>

              <div className="card-body" style={{ height: 550, overflowY: 'scroll' }}>
                <p style={{ fontSize: '20px' }}>View All Booking Categories</p>

                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Name</th>
                      <th scope="col">Slug</th>
                      <th scope="col">Status</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bookingData?.length > 0 ? (
                      bookingData.map((res, index) => (
                        <tr key={res.id}>
                          <th scope="row">{index + 1}</th>
                          <td>{res.name}</td>
                          <td>{res.slug}</td>
                          <td>{res.status === 1 ? 'Active' : 'Inactive'}</td>
                          <td>
                            <button
                              className="py-2 mx-2"
                              style={{
                                backgroundColor: '#3cc3b0',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px'
                              }}
                              onClick={() => {
                                ShowById(res.id);
                                setErrors({});
                              }}
                              data-bs-toggle="offcanvas"
                              data-bs-target="#offcanvasRight"
                              aria-controls="offcanvasRight"
                            >
                              Edit
                            </button>
                            <button
                              onClick={() => deletePost(res.id)}
                              className="py-2"
                              style={{
                                backgroundColor: '#9ba322',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px'
                              }}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {bookingData?.length === 0 && (
                  <div className="data-not-found text-center">
                    <h2 className="bounce">Data Not Found</h2>
                    <p className="fade-in">Sorry, the requested data could not be found.</p>
                  </div>
                )}
              </div>

              <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                <BasicPagination count={totalPage} onChange={e => getPostShow(e)} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===== Offcanvas Form ===== */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
        data-bs-keyboard="false"
        style={{ width: '90%' }}
      >
        <div className="offcanvas-header">
          <h5 id="offcanvasRightLabel">
            {IsEdit ? 'Update Booking Category' : 'Add Booking Category'}
          </h5>
          <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>

        <div className="offcanvas-body">
          <CommanInput
            value={Data.name}
            placeholder="Name"
            type="text"
            describtionShow={true}
            desTitle="Name"
            onChange={e => {
                setData({ ...Data, name: e });
                setErrors(prev => ({ ...prev, name: '' })); // clear error on change
            }}
            required={true} 
          />
          {errors.name && <span className="text-danger">{errors.name}</span>}

          <CommanInput
            value={Data.slug}
            placeholder="Slug"
            type="text"
            describtionShow={true}
            desTitle="Slug"
            onChange={e => {
                setData({ ...Data, slug: e });
                setErrors(prev => ({ ...prev, slug: '' }));
            }}
          />
          {errors.slug && <span className="text-danger">{errors.slug}</span>}

          <CommanInput
            placeholder="Category Image"
            fileInput={true}
            input={false}
            textArea={false}
            describtionShow={true}
            desTitle="Category Image"
            onChange={e => {
              const file = e.target.files[0];
              setData({ ...Data, category_images: URL.createObjectURL(file) });
              setImage(file);
            }}
            accept="image/*"
          />

          <div className="col-2">
            {Data.category_images && (
              <img
                className="w-100"
                src={Data.category_images}
                alt="preview"
                style={{ width: 100, borderRadius: 6, border: '1px solid #ddd' }}
              />
            )}
          </div>

          <CommanInput
            value={Data.title_one}
            placeholder="Title One"
            type="text"
            describtionShow={true}
            desTitle="Title One"
            onChange={e => {
              setData({ ...Data, title_one: e });
              setErrors(prev => ({ ...prev, title_one: '' }));
            }}
            required={true}
          />
          {errors.title_one && <span className="text-danger">{errors.title_one}</span>}

          <CommanInput
            value={Data.title_two}
            placeholder="Title Two"
            type="text"
            describtionShow={true}
            desTitle="Title Two"
            onChange={e => {
              setData({ ...Data, title_two: e });
              setErrors(prev => ({ ...prev, title_two: '' }));
            }}
            required={true}
          />
          {errors.title_two && <span className="text-danger">{errors.title_two}</span>}

          <CommanInput
            value={Data.title_third}
            placeholder="Title Third"
            type="text"
            describtionShow={true}
            desTitle="Title Third"
            onChange={e => {
              setData({ ...Data, title_third: e });
              setErrors(prev => ({ ...prev, title_third: '' }));
            }}
            required={true}
          />
          {errors.title_third && <span className="text-danger">{errors.title_third}</span>}

          <CommanInput
            value={Data.title_four}
            placeholder="Title Four"
            type="text"
            describtionShow={true}
            desTitle="Title Four"
            onChange={e => {
              setData({ ...Data, title_four: e });
              setErrors(prev => ({ ...prev, title_four: '' }));
            }}
            required={true}
          />
          {errors.title_four && <span className="text-danger">{errors.title_four}</span>}

          <CommanInput
            value={Data.title_five}
            placeholder="Title Five"
            type="text"
            describtionShow={true}
            desTitle="Title Five"
            onChange={e => {
              setData({ ...Data, title_five: e });
              setErrors(prev => ({ ...prev, title_five: '' }));
            }}
            required={true}
          />
          {errors.title_five && <span className="text-danger">{errors.title_five}</span>}

          <CommanInput
            value={Data.about_tour_title}
            placeholder="About Tour Title"
            type="text"
            describtionShow={true}
            desTitle="About Tour Title"
            onChange={e => {
              setData({ ...Data, about_tour_title: e });
              setErrors(prev => ({ ...prev, about_tour_title: '' }));
            }}
            required={true}
          />
          {errors.about_tour_title && <span className="text-danger">{errors.about_tour_title}</span>}

<div className="mb-3">
  <label className="form-label fw-semibold">Explore Blog</label>

  <Select
    isMulti
    isSearchable
    options={relatedPostList.map(post => ({
      value: post.value,
      label: post.name
    }))}
    value={selectedPostIds.map((id, i) => ({
      value: id,
      label: selectedPostNames[i]
    }))}
    onChange={(selectedOptions) => {
      const ids = selectedOptions.map(opt => opt.value);
      const names = selectedOptions.map(opt => opt.label);

      setSelectedPostIds(ids);
      setSelectedPostNames(names);
    }}
    placeholder="Search & select blog posts..."
    className="react-select-container"
    classNamePrefix="react-select"
  />
</div>


          <div className="mb-2">
            <label className="form-label" style={{ fontWeight: '600' }}>About Tour</label>
            <div style={{ border: "1px solid gray" }}>
              <Editor
                editorState={Data.about_tour}
                toolbarClassName="toolbarClassName"
                wrapperClassName="wrapperClassName"
                editorClassName="editorClassName"
                onEditorStateChange={(e) => {
                  setData({ ...Data, about_tour: e });
                  setErrors(prev => ({ ...prev, about_tour: '' }));
                }}
              />
            </div>
            {errors.about_tour && <span className="text-danger">{errors.about_tour}</span>}
          </div>

          <div className="mb-2">
            <label className="form-label" style={{ fontWeight: '600' }}>SEO Content</label>
            <small className="d-block text-muted mb-1">Long-form content for SEO. Shown at the bottom of the category page on the website.</small>
            <div style={{ border: "1px solid gray" }}>
              <Editor
                editorState={Data.seo_content}
                toolbarClassName="toolbarClassName"
                wrapperClassName="wrapperClassName"
                editorClassName="editorClassName"
                onEditorStateChange={(e) => {
                  setData({ ...Data, seo_content: e });
                }}
              />
            </div>
          </div>

          <CommanInput
            placeholder="Booking Header Images"
            fileInput={true}
            input={false}
            textArea={false}
            multiple={true}
            describtionShow={true}
            desTitle="Booking Header Images (Multiple)"
            onChange={AddBookingHeaderImages}
            accept="image/*"
          />

          <div className="row">
            {Data.images?.map((item, index) => (
              <div key={index} className="col-4 mb-3">
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  <img
                    src={item.img_path}
                    alt={`preview-${index}`}
                    style={{
                      width: 100,
                      height: 100,
                      objectFit: 'cover',
                      borderRadius: 6,
                      border: '1px solid #ddd'
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => DeleteBookingHeaderImage(index)}
                    style={{
                      position: 'absolute',
                      top: -5,
                      right: 5,
                      backgroundColor: '#dc3545',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '50%',
                      width: 25,
                      height: 25,
                      cursor: 'pointer',
                      fontSize: '14px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    ×
                  </button>
                </div>
                <input
                  type="text"
                  className="form-control mt-2"
                  placeholder="Image Text / Alt Text"
                  value={item.img_txt || ''}
                  onChange={(e) => {
                    const updated = [...Data.images];
                    updated[index].img_txt = e.target.value;
                    setData({ ...Data, images: updated });
                  }}
                />
              </div>
            ))}
          </div>

          <CommanDropDown
            displayValue="Status"
            value={Data.status}
            title="Please Select"
            desTitle="Status"
            Data={StatusData}
            onChange={e => setData({ ...Data, status: Number(e) })}
            required={true} 
          />

          <Button
            className="mt-3"
            onClick={() => handleSubmit()}
          >
            {IsEdit ? 'Update' : 'Submit'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BookingCategories;
